import { VelavuFloor } from "velavu-js-api";
import { PendingFloorDuplication } from "../../../../../state/floor/floor-duplicate";

export default interface FloorListEntry {
	id: number | string;
	loading: boolean;
	level: number;
	name: string;
	floorID: string | null;
}

export function floorListEntryFromFloor(floor: VelavuFloor): FloorListEntry {
	return {
		id: floor.id,
		loading: false,
		level: floor.level,
		name: floor.name,
		floorID: floor.id,
	};
}

export function floorListEntryFromPendingFloorDuplication(
	pending: PendingFloorDuplication,
): FloorListEntry {
	return {
		id: pending.id,
		loading: true,
		level: pending.level,
		name: pending.name,
		floorID: null,
	};
}
